import React from 'react'

import address from "./../../../UI/Modal/location.svg"
import waze from "./../../../UI/Modal/waze.svg"
import phones from './../../../UI/Modal/phone.svg'

import googleMaps from './../../../UI/Modal/maps.svg'


interface ContactLocationProps {
  isLocationOpened: boolean,
  logoConstructora: string,
  colorsData: any,
  contactData: any,
  isContactModalOpened: boolean
}
declare const window: any;

const ContactLocationMobile = ({isLocationOpened, logoConstructora, colorsData, contactData, isContactModalOpened}: ContactLocationProps) => {

  return(
    <div className={isLocationOpened && isContactModalOpened ? "contact-location-mobile fade-in":"contact-location-mobile fade-out"}>
      <div className='contact-location-logo-container'>
        <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/")+logoConstructora} alt=""></img>
      </div>
      <div className='contact-location-salas-container'>
        {
          contactData.map((contact: any, index: number) => 
            <div className='contact-salas-container-mobile'>
              <div className='contact-salas-container-name-mobile'>{contact.name.toUpperCase()}</div>
              <div className="sala-individual-address-mobile">
                  <img src={address} alt=""/>
                  <div className="sala-addres-container-mobile">
                      <div className="sala-individual-address-info-mobile">{contact.location}</div>
                  </div>
              </div>
              {
                                           contact.URLWaze !== "" ?
                                            <div className="sala-individual-waze-mobile">
                                                <img src={waze} alt=""></img>
                                                <a href={contact.URLWaze} target="_blank" rel="noreferrer">
                                                    Planea cómo llegar - Waze
                                                </a>
                                            </div>:null
                                        }
              {
                                            contact.URLMaps !== "" ?
                                            <div className="sala-individual-waze-mobile">
                                                <img src={googleMaps} alt=""></img>
                                                <a href={contact.URLMaps} target="_blank" rel="noreferrer">
                                                    Planea cómo llegar - Google Maps
                                                </a>
                                            </div>:null
                                        }
                                        {
                                            <div className="sala-phones-container-mobile">
                                                <div className="sala-phones-image-container-mobile">
                                                    <img src={phones} alt=""></img>
                                                </div>
                                                <div className="phone-container-mobile">
                                                {
                                                    contact.phones.map((phone: any) => {
                                                        return(
                                                          
                                                                
                                                                    phone.whatsapp === "true" ?
                                                                    <a href={'https://wa.me/'+phone.number.replace('+','')}>{phone.number.slice(0,3)+' '+phone.number.slice(3)}</a>:
                                                                    <div>{phone.number.slice(0,3)+' '+phone.number.slice(3)}</div>
                                                                
                                                            
                                                        )
                                                    })
                                                }
                                                </div>
                                            </div>
                                        }
              <br></br>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default ContactLocationMobile